let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g7Lmu")).then(() => parcelRequire('54qAt'));